import { caseStudies } from '../data/caseStudies';
import './CaseStudies.scss';

function CaseStudies() {
  return (
    <section id="case-studies" className="case-studies">
      <div className="container">
        <span className="section-eyebrow">Case Studies</span>
        <h2 className="section-title">Proof that niche problems can ship fast</h2>
        <div className="case-studies__grid">
          {caseStudies.map((study) => (
            <article key={study.title} className="case-studies__card">
              <div className="case-studies__text">
                <h3>{study.title}</h3>
                <div className="case-studies__summary-grid">
                  {[
                    { label: 'Challenge', value: study.challenge },
                    { label: 'Solution', value: study.approach },
                    { label: 'Result', value: study.result }
                  ].map((item) => (
                    <div key={item.label} className="case-studies__summary-card">
                      <span className="case-studies__summary-label">{item.label}</span>
                      <p>{item.value}</p>
                    </div>
                  ))}
                </div>
                <div className="tag-list">
                  {study.tags.map((tag) => (
                    <span key={tag}>{tag}</span>
                  ))}
                </div>
              </div>
              <div className="case-studies__media">
                {study.images.map((image) => (
                  <figure key={image.src}>
                    <img src={image.src} alt={image.alt} loading="lazy" />
                  </figure>
                ))}
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}

export default CaseStudies;
